export interface NavLink {
  label: string;
  hash: string;
}

export const NAV_LINKS: NavLink[] = [
  { label: '实时热搜', hash: '#hot' },
  { label: '塌房名单', hash: '#roster' },
  { label: '黑料合集', hash: '#bundle' },
  { label: '翻车时间线', hash: '#timeline' },
  { label: '深扒专题', hash: '#digging' },
];

export interface HotItem {
  rank: string;
  title: string;
  tag: '爆' | '热' | '新';
  heat: string;
  summary: string;
}

export const HOT_LIST: HotItem[] = [
  { rank: '01', title: '情感区一姐被爆长期「挂榜收割」粉丝', tag: '爆', heat: '1286万', summary: '前后两轮直播翻车对比被扒出，实锤话术几乎一字不差。' },
  { rank: '02', title: '带货榜 Top 主播翻车现场：承诺佣金对不上账', tag: '爆', heat: '972万', summary: '商家晒后台结算截图，与主播口中版本相差三倍，吃瓜群已吵翻。' },
  { rank: '03', title: '千万粉颜值主播深夜旧照被深扒', tag: '热', heat: '641万', summary: '妆前妆后差异过大，粉丝直呼塌房到「没眼看」。' },
  { rank: '04', title: '测评网红翻车现场：三款充电宝实测全打脸', tag: '热', heat: '485万', summary: '以「只讲真话」人设起家，如今人设与实测双双翻车。' },
  { rank: '05', title: '口嗨主播合同纠纷开庭，官司打了一年', tag: '新', heat: '318万', summary: '被曝长期拖欠陪玩分成，法庭细节持续被吃瓜群众搬运。' },
  { rank: '06', title: '户外主播「剧本式偶遇」被监控视频打脸', tag: '新', heat: '206万', summary: '同一街角一周连录三次偶遇，评论区直接封神「奥斯卡」。' },
];

export interface RosterRow {
  index: string;
  name: string;
  area: string;
  status: '已塌房' | '深扒中' | '已辟谣';
  statusTone: 'primary' | 'accent' | 'secondary';
  summary: string;
  cover: string;
}

export const ROSTER_LIST: RosterRow[] = [
  {
    index: '01',
    name: '阿柚·情感',
    area: '情感连麦',
    status: '已塌房',
    statusTone: 'primary',
    summary: '人设「人间清醒」，实为写好的剧本，连麦哭戏被扒到重复镜头。',
    cover: 'https://readdy.ai/api/search-image?query=Moody%20backstage%20portrait%20of%20a%20faceless%20figure%20lit%20only%20by%20a%20ring%20light%20glow%2C%20phone%20screen%20reflecting%20warm%20light%2C%20dark%20crimson%20and%20black%20palette%2C%20cinematic%20film%20grain%2C%20editorial%20gossip%20news%20photo%2C%20high%20contrast%2C%20clean%20empty%20background&width=600&height=800&seq=roster-01&orientation=portrait',
  },
  {
    index: '02',
    name: '老K测评',
    area: '数码测评',
    status: '已塌房',
    statusTone: 'primary',
    summary: '「只讲真话」的数码博主，同一款产品前后两个版本结论完全相反。',
    cover: 'https://readdy.ai/api/search-image?query=Shadowy%20faceless%20tech%20reviewer%20silhouette%20holding%20a%20smartphone%20with%20glowing%20screen%2C%20dark%20studio%20with%20amber%20accent%20lighting%2C%20empty%20clean%20background%2C%20editorial%20documentary%20style%2C%20film%20grain%2C%20moody%20and%20dramatic%2C%20no%20visible%20face&width=600&height=800&seq=roster-02&orientation=portrait',
  },
  {
    index: '03',
    name: 'Momo酱',
    area: '颜值直播',
    status: '深扒中',
    statusTone: 'accent',
    summary: '深夜旧照流出，妆前后判若两人，粉丝蹲点求「一键卸妆」。',
    cover: 'https://readdy.ai/api/search-image?query=Backlit%20faceless%20young%20woman%20in%20front%20of%20a%20vanity%20mirror%20with%20warm%20makeup%20lights%2C%20silhouette%20only%2C%20soft%20crimson%20and%20dusty%20pink%20tones%2C%20editorial%20portrait%2C%20empty%20clean%20background%2C%20no%20identity%20shown&width=600&height=800&seq=roster-03&orientation=portrait',
  },
  {
    index: '04',
    name: '大王带你看',
    area: '户外探店',
    status: '深扒中',
    statusTone: 'accent',
    summary: '「随机偶遇」连录三场都被拍到同一路人客串，剧本痕迹过重。',
    cover: 'https://readdy.ai/api/search-image?query=Film%20set%20silhouette%20with%20handheld%20camera%20and%20booms%20against%20a%20night%20street%2C%20warm%20neon%20and%20deep%20shadows%2C%20faceless%20production%20crew%2C%20editorial%20gossip%20documentary%20mood%2C%20clean%20composition%2C%20no%20face%20visible&width=600&height=800&seq=roster-04&orientation=portrait',
  },
  {
    index: '05',
    name: '甜茶局',
    area: '连麦陪玩',
    status: '已辟谣',
    statusTone: 'secondary',
    summary: '分成纠纷闹上法庭，后双方庭外和解，实锤不足，名单暂缓。',
    cover: 'https://readdy.ai/api/search-image?query=Minimal%20faceless%20figure%20sitting%20at%20a%20desk%20typing%20in%20a%20dim%20room%2C%20single%20warm%20desk%20lamp%20pool%20of%20light%2C%20editorial%20documentary%20photography%2C%20muted%20stone%20and%20amber%20tones%2C%20clean%20empty%20background&width=600&height=800&seq=roster-05&orientation=portrait',
  },
  {
    index: '06',
    name: '阿皮快跑',
    area: '生活日常',
    status: '深扒中',
    statusTone: 'accent',
    summary: '「真实日常」疑似租的样板间，网友逐帧对比墙纸一致。',
    cover: 'https://readdy.ai/api/search-image?query=Faceless%20person%20filming%20with%20a%20smartphone%20on%20a%20gimbal%20in%20a%20staged%20apartment%2C%20neutral%20warm%20lighting%2C%20documentary%20gossip%20editorial%20style%2C%20empty%20clean%20background%2C%20no%20identity%20shown&width=600&height=800&seq=roster-06&orientation=portrait',
  },
];

export interface BundleItem {
  title: string;
  desc: string;
  size: string;
  count: string;
  tag: string;
  cover: string;
}

export const BUNDLE_LIST: BundleItem[] = [
  {
    title: '情感翻车合集打包',
    desc: '连麦剧本、话术录音、前后反差片段一网打尽，含完整时间轴标注。',
    size: '1.2GB',
    count: '87 条',
    tag: '本期最热',
    cover: 'https://readdy.ai/api/search-image?query=Stack%20of%20audio%20files%20and%20folders%20rendered%20as%20abstract%20red%20glass%20tiles%20on%20a%20dark%20surface%2C%20glowing%20crimson%20data%20archive%2C%20editorial%20tech%20illustration%2C%20clean%20high%20contrast%2C%20empty%20background&width=800&height=500&seq=bundle-01&orientation=landscape',
  },
  {
    title: '测评翻车现场实录',
    desc: '同一产品双版本实测逐帧对比，商家结算截图与口播承诺对照整理。',
    size: '860MB',
    count: '63 条',
    tag: '实锤集中',
    cover: 'https://readdy.ai/api/search-image?query=Abstract%20amber%20and%20black%20data%20archives%20of%20comparison%20charts%20and%20timelines%20floating%20over%20a%20dark%20background%2C%20editorial%20documents%20illustration%2C%20clean%20minimal%2C%20high%20contrast%2C%20empty%20background&width=800&height=500&seq=bundle-02&orientation=landscape',
  },
  {
    title: '颜值前后面部档案',
    desc: '高清旧照 × 直播同框逐帧对照，高清原图保留，一键查看变化。',
    size: '540MB',
    count: '41 条',
    tag: '吃瓜必存',
    cover: 'https://readdy.ai/api/search-image?query=Mirror%20reflection%20and%20polaroid%20photos%20scattered%20as%20abstract%20dusty%20pink%20and%20deep%20red%20shapes%20on%20dark%2C%20mysterious%20editorial%20collage%2C%20clean%20minimal%2C%20no%20faces%2C%20empty%20background&width=800&height=500&seq=bundle-03&orientation=landscape',
  },
];

export interface FeatureItem {
  cover: string;
  title: string;
  label: string;
  digest: string;
}

export const FEATURE_LIST: FeatureItem[] = [
  {
    cover: 'https://readdy.ai/api/search-image?query=Dark%20editorial%20scene%20of%20a%20live%20streaming%20monitor%20wall%20with%20glowing%20red%20screens%2C%20empty%20broadcast%20room%20at%20night%2C%20crimson%20and%20black%2C%20cinematic%20documentary%20gossip%20news%2C%20clean%20minimal%2C%20no%20text&width=800&height=600&seq=dig-01&orientation=landscape',
    label: '情感话术怎么套现',
    title: '深扒：一场连麦如何「剧本化收割」上万打赏',
    digest: '从开场铺垫到哭戏推进，再到引导送礼，三个阶段的固定话术被逐句拆解。',
  },
  {
    cover: 'https://readdy.ai/api/search-image?query=Warm%20amber%20analog%20timer%20and%20video%20timeline%20scrubber%20bars%20floating%20over%20dark%20texture%2C%20forensic%20review%20mood%2C%20editorial%20documentary%20illustration%2C%20clean%20minimal%2C%20no%20faces%2C%20no%20text&width=800&height=600&seq=dig-02&orientation=landscape',
    label: '测评结论怎么造假',
    title: '同一款产品两种结论：测评翻车的「双版本」工程',
    digest: '一份针对发货版本、一份针对送测版本，中间的差价就是舆论操控空间。',
  },
  {
    cover: 'https://readdy.ai/api/search-image?query=Faceless%20audience%20silhouettes%20watching%20a%20glowing%20phone%20screen%20in%20a%20dark%20cinema%2C%20single%20hot%20light%20source%2C%20crimson%20and%20black%2C%20editorial%20gossip%20culture%2C%20clean%20minimal%2C%20no%20faces&width=800&height=600&seq=dig-03&orientation=landscape',
    label: '吃瓜风向变了',
    title: '从「破防」到「当戏看」：翻车现场正在重塑粉丝关系',
    digest: '围观者的心态早已更新：不再较真人设，只当一场随时开演的连续剧。',
  },
];

export interface TimelineEvent {
  date: string;
  weekday: string;
  title: string;
  body: string;
  tone: 'primary' | 'accent';
}

export const TIMELINE: TimelineEvent[] = [
  {
    date: '09',
    weekday: '周一',
    title: '情感区连麦录音完整流出',
    body: '三段连麦音频对拍，粉丝总结出近乎一致的「收割公式」。',
    tone: 'primary',
  },
  {
    date: '07',
    weekday: '周六',
    title: '测评双版本结论对不上账',
    body: '送测版与发货版结论相反，商家晒出后台结算截图。',
    tone: 'primary',
  },
  {
    date: '04',
    weekday: '周三',
    title: '颜值主播深夜旧照被搬运',
    body: '旧照与新镜头逐帧对照帖冲上同城热门，评论区两极。',
    tone: 'accent',
  },
  {
    date: '02',
    weekday: '周一',
    title: '户外「偶遇」剧本被视频打脸',
    body: '同一街角一周连录三场，路人都看熟了眼熟群众演员。',
    tone: 'accent',
  },
];

export const HOT_KEYWORDS: string[] = [
  '塌房名单',
  '黑料合集打包',
  '情感话术',
  '测评翻车现场',
  '旧照深扒',
  '剧本偶遇',
  '挂榜收割',
  '辟谣反转',
];